import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux';
import { Link } from 'react-router-dom'
import Hashids from 'hashids';

import { 
  logOut,
  newBlankPattern,
  newDrawingPattern,
  setLoginModalOpen,
  setCurrentTeam,
  unsetCurrentTeam,
  showTooltip,
  hideTooltip,
  tryToGetTeamPatterns
} from '../../actions/actions.export.js';

import Button from '../Button/Button.js'
import version from '../../version.js';

import './UserDropdown.css';

var hashids = new Hashids('k100p');

class UserDropdown extends Component {

  render(){
    const { dispatch, user, team, patternManager } = this.props; 

    var pattern = patternManager.cache[patternManager.current_pattern];

    var dropdown_items = [];

    
    var team_list = []
    for(var i in team.cache){
      team_list.push(team.cache[i]);
    }

    if(team_list.length > 0 && !user.roles.enterprise){

      dropdown_items.push(<div className="dropdown-item dropdown-item-muted dropdown-item-blank">
        <small className="translucent text-700">
          CHANGE WORKSPACE
        </small>
      </div>)
      dropdown_items.push(<span
          key={i} 
          className={"dropdown-item dropdown-item-muted dropdown-item-flex dropdown-item-link  " + (!team.current ? "dropdown-item-active" : "translucent")}
          onClick={(e)=>{ 
            dispatch(unsetCurrentTeam());
          }}
          >
          <span className="dropdown-item-icon">
            {
              !team.current ?
              <i className="fas fa-user fa-fw fa-lg"/>
              :
              <i className="fal fa-user fa-fw fa-lg"/>
            }
          </span>
          <span className="dropdown-item-label">
            Your {user.roles.pro ? "Pro" : "personal"} account
          </span>
          {
            !team.current && <i className="fas fa-check text-success"/>
          }
        </span>)
      
      var n = team_list.map((t)=> {
        return <span
          className={"dropdown-item dropdown-item-muted dropdown-item-flex dropdown-item-link  " + (t.id === team.current ? "dropdown-item-active" : "translucent")}
          onClick={(e)=>{ 
            dispatch(tryToGetTeamPatterns({ id: t.id }))
            dispatch(setCurrentTeam(t.id));
          }}
          >
          <span className="dropdown-item-icon">
            {
              t.id === team.current ?
              <i className="fas fa-users fa-fw fa-lg"/>
              :
              <i className="fal fa-users fa-fw fa-lg"/>
            }
          </span>
          <span className="dropdown-item-label text-ellipsis">
            {t.display_name} 
          </span>
          {
            t.id === team.current && <i className="fas fa-check text-success"/>
          }

        </span>
      })

      dropdown_items = dropdown_items.concat(n);
      
      dropdown_items.push(<div className="dropdown-divider"></div>);
    }

    let settingsURL = "/settings";
    if(!user.roles.enterprise){ 
      if(team.current && team.cache[team.current]){
        if(team.cache[team.current].isFirm){
          settingsURL += "/firm/" + hashids.encode(team.cache[team.current].id);
        } else {
          settingsURL += "/team/" + hashids.encode(team.cache[team.current].id);
        }
      }
    }

    dropdown_items.push(<Link to={settingsURL} className="dropdown-item dropdown-item-flex dropdown-item-link">
        <span className="dropdown-item-icon">
          <i className="fal fa-cog fa-fw fa-lg"/>
        </span>
        <span className="dropdown-item-label">
          Account Settings
        </span>
      </Link>);

    if(!user.roles.enterprise){
      dropdown_items.push( <Link to="/at-work" className="dropdown-item dropdown-item-flex dropdown-item-link">
        <span className="dropdown-item-icon">
          <i className="fal fa-users-medical fa-fw fa-lg"/>
        </span>
        <span className="dropdown-item-label">
          Pattycake at Work
        </span>
      </Link>)
    }

    if(!user.roles.pro && !user.roles.enterprise){
      dropdown_items.push(<Link to={"/settings/my-account/upgrade-to-pro"} className="dropdown-item dropdown-item-flex dropdown-item-link">
        <span className="dropdown-item-icon">
          <i className="fal fa-sparkles fa-fw fa-lg"/>
        </span>
        <span className="dropdown-item-label">
          Upgrade to Pro
        </span>
      </Link>);
    }

    dropdown_items = dropdown_items.concat([
      <div className="dropdown-divider"></div>
      ,
      <Link to="/logout" className="dropdown-item dropdown-item-flex dropdown-item-link">
        <span className="dropdown-item-icon">
          <i className="fal fa-door-open fa-fw fa-lg"/>
        </span>
        <span className="dropdown-item-label">
          Log Out
        </span>
      </Link>
      ,
      <div className="dropdown-item text-right dropdown-item-blank">
        <small className="">
          v{version}{user.isLoggedIn ? (team.current ? "t" : (user.roles.pro ? "p" : "f")) : "a"}
        </small>
      </div>
    ])



    return (
      <div className="user-dropdown">
        {
          !this.props.dropdownOnly &&
          <span>
            <Link to="/settings/my-account/pending-invitations" className={"relative user-dropdown-shortcut-link " + (user.pendingInvites.length == 0 && "translucent")}>
              <i className="fal fa-bell"/>
              {
                user.pendingInvites.length > 0 && <i className="fas fa-circle icon-dot"/>
              }
            </Link>
            <Link to={settingsURL} className="user-dropdown-shortcut-link"><i className="fal fa-cog"/></Link>
            <span className="user-dropdown-shortcut-divider">|</span>
          </span>
        }
        <Button 
          display={
            <span className="text-400" style={{fontSize: 14}}>
              { !this.props.hideName && user.display_name} <i className="far fa-angle-down fa-fw"/>
            </span>
          }
          size="icon" 
          color="transparent"
          hoverTextColor="primary"
          dropdownOnly={true}
          dropdown={dropdown_items}
          dropdownIcon={<span/>}
          />
      </div>
    )
  }
}

const mapStateToProps = (state) => {      
  const { user, team, patternManager } = state;

  return {
    user, team, patternManager
  }
}

export default connect(mapStateToProps)(UserDropdown);



// WEBPACK FOOTER //
// ./src/components/UserDropdown/UserDropdown.js